module.exports = __webpack_public_path__ + "img/grey.5b0ae44.svg";